import { render, staticRenderFns } from "./vLink.vue?vue&type=template&id=4d410b60&scoped=true&"
import script from "./vLink.vue?vue&type=script&lang=js&"
export * from "./vLink.vue?vue&type=script&lang=js&"
import style0 from "./vLink.vue?vue&type=style&index=0&id=4d410b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d410b60",
  null
  
)

export default component.exports